import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { boardPortfolio, boardRoleTypes, fiduciaryStatement, sectors } from '../data/portfolio';
import { Label } from './Label';
export function BoardExperience() {
  const [open, setOpen] = useState<string | null>(boardPortfolio[0]?.company ?? null);
  return <section id="boards" aria-labelledby="boards-heading" className="scroll-mt-20 bg-ink-900 px-6 py-24 md:px-10 md:py-32" data-id="element-24" data-mp="2ule1ebdheao">
      <div className="mx-auto w-full max-w-edge" data-id="element-25" data-mp="3u1o7ydilhyol">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-26" data-mp="3pzb3rtjhy8tx">
          <div className="lg:col-span-4" data-id="element-27" data-mp="3pxq79ydmgftf">
            <Label data-id="element-28" data-mp="3l0qayf6kqrfi">Board Experience</Label>
          </div>
          <div className="lg:col-span-8" data-id="element-29" data-mp="3l06vd54ecf4n">
            <h2 id="boards-heading" className="font-display text-3xl font-normal leading-[1.14] text-paper md:text-[3.25rem]" data-id="element-30" data-mp="2ek4gk8s4665s">
              Board experience across technology, security &amp; data
            </h2>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-stone md:text-lg" data-id="element-31" data-mp="3okox2jl15f5l">
              Ten further appointments held alongside the fund mandates — as{' '}
              {boardRoleTypes.join(' · ')} — across technology businesses and investment
              situations in {sectors.slice(0, 4).join(', ').toLowerCase()} and beyond.
            </p>
            <p className="mt-6 max-w-2xl border-l border-brass/60 pl-5 text-[0.9rem] leading-relaxed text-fog" data-id="element-32" data-mp="35scym7xhyy0q">
              {fiduciaryStatement}
            </p>
          </div>
        </div>

        <ul className="mt-20 border-t border-white/15 md:mt-24" data-id="element-33" data-mp="2wtiu7vdxd3cm">
          {boardPortfolio.map(role => {
          const isOpen = open === role.company;
          const panelId = `board-panel-${role.company.replace(/\W+/g, '-').toLowerCase()}`;
          return <li key={role.company} className="border-b border-white/15" data-id="element-34" data-mp="2rtd9z09zij4k">
                <h3 data-id="element-35" data-mp="2rvpmgxwz41a8">
                  <button type="button" onClick={() => setOpen(isOpen ? null : role.company)} aria-expanded={isOpen} aria-controls={panelId} className="group flex w-full items-start gap-6 py-8 text-left focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-brass" data-id="element-36" data-mp="xd65xo5r2jrk">
                    <span className="grid flex-1 gap-3 lg:grid-cols-12 lg:items-baseline lg:gap-8" data-id="element-37" data-mp="1gb90sjkzbaxa">
                      <span className="font-display text-2xl leading-tight text-paper transition-colors duration-150 ease-editorial group-hover:text-brass lg:col-span-4 md:text-[1.75rem]" data-id="element-38" data-mp="1cbqg9ox2l1uz">
                        {role.company}
                      </span>
                      <span className="text-[0.95rem] leading-relaxed text-stone lg:col-span-4" data-id="element-39" data-mp="3s1tgpp67l1da">
                        {role.descriptor}
                        {role.outcome && <span className="mt-1 block text-[0.8rem] uppercase tracking-[0.16em] text-mint" data-id="element-40" data-mp="3n4tbthl3i4nr">
                            {role.outcome}
                          </span>}
                      </span>
                      <span className="text-[0.8rem] uppercase tracking-[0.18em] text-fog lg:col-span-4 lg:text-right" data-id="element-41" data-mp="3mwfvdmb32837">
                        {role.role} · {role.period}
                      </span>
                    </span>
                    <span className="mt-1.5 shrink-0 text-fog transition-colors duration-150 ease-editorial group-hover:text-brass" aria-hidden="true" data-id="element-42" data-mp="3voht3ctrpa9s">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-43" data-mp="eh61v2l9eb71" /> : <PlusIcon className="h-4 w-4" data-id="element-44" data-mp="eethyjvxxqrc" />}
                    </span>
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-45" data-mp="2g9kcrhpdyfdy">
                  {isOpen && <motion.div id={panelId} key="panel" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.24,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-46" data-mp="ajh2hwq8inai">
                      <ul className="grid gap-x-12 gap-y-4 pb-10 lg:grid-cols-2" data-id="element-47" data-mp="3n26t1dw1imjw">
                        {role.achievements.map(achievement => <li key={achievement} className="border-t border-white/10 pt-4 text-[0.95rem] leading-relaxed text-paper/85" data-id="element-48" data-mp="lsvo8fctpbz">
                            {achievement}
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}